import {styled} from "styled-components";
import usePopUpCtrl from "../../hooks/usePopUpCtrl";

const PopupWrapper = styled.div`
  _display: none;
  z-index: 10000;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: var(--overlay);
  
  &.on {
    display: block;
  }

`
const PopupInner = styled.div`
  position: absolute;
  z-index: 10005;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  padding: var(--card-y) var(--card-x);
  box-sizing: border-box;
  max-width: calc(100% - 32px);
  border-top: 3px solid var(--danger);
  border-radius: var(--radius);
  background-color: var(--panel);
`


const Alertpopup = ({ children }) => {

    const { open } = usePopUpCtrl()

    return (
        <PopupWrapper className={open ? 'on' : ''}>
           <PopupInner>
               {children}
           </PopupInner>
        </PopupWrapper>
    )
}

export default Alertpopup